import React, { useEffect, useState, useCallback, } from 'react';
import { Paper, Grid, Stepper, Step, StepButton,
} from '@mui/material';
import PropertyInfo from './PropertyInfo';
import { useSnackbar } from 'notistack';
import { useNavigate } from "react-router-dom";
import LocationInfo from './LocationInfo';
import UserInfo from './UserInfo';
import { getCities, saveLibrary } from 'services/property';

const AddLisitng = () => {

  const steps = ['Tell us about yout property', 'Pin your property\'s exact  location', 'Tell us about you'];

  /** Hooks */
  const [cities, setCities] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const [propertyData, setPropertyData] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  let navigate = useNavigate();
  useEffect(() => {
    getCityList();
    return () => {};
  }, []);

  const getCityList = () => {
    getCities().then(({response, error}) => {
      if(response){
        setCities([...response]);
      } else {
        // enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }


  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  // const handleStep = (step, label) => () => {
  //     setActiveStep(step);
  // };

  const handleComplete = useCallback(() => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    if(!isLastStep()){
      handleNext();
    }
  }, [activeStep, setCompleted, completed]);

  // const handleReset = () => {
  //   setActiveStep(0);
  //   setCompleted({});
  // };

  const onSuccess = useCallback((libraryData) => {
    setPropertyData({...propertyData, ...libraryData});
    handleComplete();
  }, [handleComplete,propertyData]);

  const getFormattedPostData = (data) => {
    return {
      name: data.name,
      address: {
        area: data.searchArea,
        city: data.city,
        location: {
          ...data.locationCoordinates
        }
      }
    };
  }

  const savePropertyData = () => {
    const postData = getFormattedPostData(propertyData);
    saveLibrary({...postData}).then(({response, error}) => {
      if(response){
        navigate('/overview');
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }


  return (
    <Paper sx={{ minWidth: 275, p: 4, minHeight: "calc(100vh - 100px )" }}>
      {/* <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        Library Details
      </Typography>
      <Divider /> */}
      <Grid container spacing={4} sx={{mt: 2}}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Stepper alternativeLabel nonLinear={false} activeStep={activeStep} sx={{pb: 2 }}>
            {steps.map((label, index) => (
              <Step key={label} completed={completed[index]}>
                <StepButton color="inherit" >
                  {label}
                  {/* {index == 2 && <Typography variant="caption" component="div">Optional</Typography>} */}
                </StepButton>
              </Step>
            ))}
          </Stepper>
        </Grid>
      </Grid>
      {activeStep === 0 ? (
        <PropertyInfo cities={cities} onSuccess={onSuccess} propertyData={propertyData} />
      ) : null}
      {activeStep === 1 ? (
          <LocationInfo onSuccess={onSuccess} onBackButtonClick={handleBack} propertyData={propertyData} />
      ) : null}
        {activeStep === 2 ? (
          <UserInfo onSuccess={savePropertyData} onBackButtonClick={handleBack} propertyData={propertyData} />
      ) : null}
    </Paper>
  );
}
 
export default React.memo(AddLisitng);
